var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2831",
    "data-name": "Rectangle 2831",
    width: 20,
    height: 20,
    transform: "translate(379 293)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path315",
    d: "M0-682.665H16.443v16.443H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5890",
    "data-name": "Mask Group 5890",
    transform: "translate(-379 -293)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g309",
    transform: "translate(380.779 977.444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g311",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g313",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g319",
    transform: "translate(0.642 0.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path321",
    d: "M-614.173-260.243v-3.212a3.212,3.212,0,0,0-3.211-3.212h-8.736a3.211,3.211,0,0,0-3.211,3.212v8.735a3.211,3.211,0,0,0,3.211,3.212h3.34",
    transform: "translate(629.332 266.666)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g323",
    transform: "translate(6.584 3.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path325",
    d: "M0,0H3.276",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g327",
    transform: "translate(8.414 8.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path329",
    d: "M-299.279-149.64a3.693,3.693,0,0,1-3.693,3.693,3.693,3.693,0,0,1-3.693-3.693,3.693,3.693,0,0,1,3.693-3.693A3.693,3.693,0,0,1-299.279-149.64Z",
    transform: "translate(306.666 153.333)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g331",
    transform: "translate(11.144 11.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path333",
    d: "M0-78.073,1.927-80",
    transform: "translate(0 80)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g335",
    transform: "translate(11.144 11.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path337",
    d: "M-78.073-78.073-80-80",
    transform: "translate(80 80)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancle);
export default __webpack_public_path__ + "static/media/cancle.c3f8b49070ea6f1d1b4ca0c7e931a2a3.svg";
export { ForwardRef as ReactComponent };